import {NodeParamsItemChunk} from "../../chunks/types/NodeParamsItemChunk";
import {getVarValueFromVarAssignmentChunk} from "./getVarValueFromVarAssignmentChunk";

export function getParamValueFromNodeParamsItemChunk(
  nodeParamsItemChunk: NodeParamsItemChunk
): string {
  const {captures: {1: varAssignmentChunk}} = nodeParamsItemChunk;
  return getVarValueFromVarAssignmentChunk(varAssignmentChunk);
}
